import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {UserLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    userConferencesPrimaryManagerDataSelector,
    userConferencesPrimaryManagerResultSelector,
} from '../../slices/user-conferences-primary-manager.slice';

type Props = {
    accountId: number,
};

export const PrimaryManagerCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(userConferencesPrimaryManagerDataSelector);
    const result = useSelector(userConferencesPrimaryManagerResultSelector);

    const manager = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !manager) {
        return null;
    }

    return (
        <UserLink
            userId={manager.userId}
            place={PLACE}
            caption={[manager.firstName, manager.lastName].filter(Boolean).join(' ') || manager.email}
        />
    );
};
